import { faFileContract } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper, DetailInfo, DetailRow } from '@labrav/common'
import { ButtonV2 } from '@labrav/react-components'
import { useStyles } from '../ViewChannelOffer.styles'
import type { ReceivedResellerAuthorization } from '../../../../modules/receivedResellerAuthorization/reducer'
import { isEmpty } from 'lodash'
import type { ChannelPartnerPrivateOffer } from '../../../../modules/channelPartnerPrivateOffer/reducer'

export const ChannelOfferEula = ({
  channelOffer,
  resellerAuthorization,
}: {
  channelOffer: ChannelPartnerPrivateOffer
  resellerAuthorization: ReceivedResellerAuthorization
}) => {
  const { classes } = useStyles()
  const openEula = (eulaFiles?: string[]) => () => {
    if (!isEmpty(eulaFiles)) {
      eulaFiles?.forEach(file => {
        const newWind = window.open(file, '_blank', 'noopener noreferrer')
        if (newWind) {
          newWind.opener = null
        }
      })
    }
  }

  return (
    <>
      <SectionWrapper
        heading="EULA details"
        icon={faFileContract}
        children={
          <div
            className={classes.section}
            data-testid="cppo-details-eula-section"
          >
            <DetailRow
              borderBottom={false}
              children={
                <>
                  <DetailInfo
                    title={'ISV EULA for buyer'}
                    keyName="endCustomerISVEula"
                    value={
                      <div className={classes.customWrapper}>
                        {resellerAuthorization?.endCustomerEulaFiles &&
                          !!resellerAuthorization?.endCustomerEulaFiles
                            ?.length && (
                            <>
                              <ButtonV2
                                styleType="link"
                                onClick={openEula(
                                  resellerAuthorization?.endCustomerEulaFiles
                                )}
                              >
                                View EULA
                              </ButtonV2>
                            </>
                          )}
                      </div>
                    }
                  />
                  {!!channelOffer?.eulaFile?.length && (
                    <DetailInfo
                      title={'Reseller EULA for buyer'}
                      keyName="endCustomerResellerEula"
                      value={
                        <div className={classes.customWrapper}>
                          {channelOffer?.eulaFile &&
                            !!channelOffer?.eulaFile?.length && (
                              <>
                                <ButtonV2
                                  styleType="link"
                                  onClick={openEula(channelOffer?.eulaFile)}
                                >
                                  View EULA
                                </ButtonV2>
                              </>
                            )}
                        </div>
                      }
                    />
                  )}
                </>
              }
            />
          </div>
        }
      />
    </>
  )
}
